export default __webpack_public_path__ + "static/media/zueggP.b889533a.jpg";